import { render, staticRenderFns } from "./usersignrecord.vue?vue&type=template&id=2f51a73c&"
import script from "./usersignrecord.vue?vue&type=script&lang=js&"
export * from "./usersignrecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports